export default "__VITE_ASSET__vjei2EZv__"